import React from "react";
import { sheduleLink } from "../../../../constant/Constant";
import { Link } from "react-router-dom";

const PricingItemsYear = ({ pricingItems, activeTab = "year" }) => {
  return (
    <div className="flex flex-wrap justify-center gap-6 px-4 py-10">
      {pricingItems?.map((card, index) => {
        let price = 0;
        let monthlyPrice = 0;
        let features = [];
        if (card.pricing?.rates.length > 0) {
          price = card.pricing?.rates.filter((it) => it?.interval === "year")[0]
            ?.amount;
          monthlyPrice = card.pricing?.rates.filter(
            (it) => it?.interval === "month"
          )[0]?.amount;
        }
        if (card?.features?.length > 0) {
          features = card.features.filter(
            (_it) => _it?.headingType === "number-of-plans"
          );
        }
        let regularPrice = Number(monthlyPrice * 12);
        let approxSaving = Math.round(
          Number(((regularPrice - price) * 100) / regularPrice)
        );
        return (
          <div
            key={index}
            className="w-[405px] h-[563px] bg-white shadow-2xl rounded-[24px] px-6 py-16 border border-gray-200"
          >
            {activeTab === "year" && (
              <div className="flex justify-center items-center w-full -mt-8">
                <div className="max-w-[282px] mx-auto text-red-500 font-Outfit text-[16px] py-2 font-semibold text-center">
                  Approx {approxSaving || 0}% Discount
                </div>
              </div>
            )}

            <div className="flex justify-center items-center">
              <div
                className={`flex justify-center items-center w-[205px] h-[68px] rounded-md  text-[20px] font-IBM font-semibold text-black ${card.bgColor}`}
              >
                {card?.name}
              </div>
            </div>
            <div className="flex justify-center items-center w-full mt-12">
              <div className="max-w-[282px] mx-auto text-black font-Outfit text-[16px] font-medium text-center">
                <div class="text-center  text-2xl">
                  <span>$</span>
                  <span class="text-5xl">{price}</span>
                  <span>{"/yr*"}</span>
                </div>
              </div>
            </div>
            <div className="flex justify-center items-center w-full mt-10">
              <div className="max-w-[282px] mx-auto text-black font-Outfit text-[16px] font-medium text-left">
                <ul className="list-disc list-outside pl-5">
                  {features?.map((item, index) => {
                    const name =
                      (item?.inputValue > 1000
                        ? "Unlimited"
                        : item?.inputValue) +
                      " " +
                      item?.name;
                    return (
                      <li key={index} className="pl-1">
                        {name}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="w-[190px] mx-auto mt-14">
              <Link
                to={sheduleLink}
                className={
                  "relative z-0 overflow-hidden flex justify-center items-center gap-2 rounded-full h-[52px] py-0 px-3 transition-all duration-200 border-black text-black border after:absolute after:h-full after:content-[''] after:-z-[1] after:top-0 after:left-0 after:transition-[width] after:duration-300 after:ease-in-out after:w-full hover:after:w-0 mx-auto after:bg-transparent hover:border-black hover:text-black capitalize font-IBM font-medium text-base mt-5"
                }
              >
                Buy
              </Link>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PricingItemsYear;
